import eventBus from '@/utils/eventBus';
import { mapState, mapMutations } from 'vuex';
export default {
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      list: [{
        name: '产品名称',
        price: '150.00元（起）'
      }, {
        name: '产品名称'
      }]
      // pageModuleShow: 1 // 1:产品列表 2:落地页
    };
  },
  computed: {
    // ...mapState('control', ['pageModuleShow']),
    pageModuleShow: {
      get() {
        return this.$store.state.control.pageModuleShow;
      },
      set(val) {
        this.$store.commit('control/SET_PAGE_SHOW', val);
      }
    }
  },
  created() {
    console.log('-----this.pageModuleShow---', this.pageModuleShow);
    // eventBus.$on('changePageShow', data => {
    //   this.pageModuleShow = data;
    // });
  },
  methods: {
    ...mapMutations({
      SET_PAGE_SHOW: 'control/SET_PAGE_SHOW'
    }),
    changePageShow() {
      this.pageModuleShow = 1;
      // this.SET_PAGE_SHOW(1);
      // eventBus.$emit('changePageShow', this.pageModuleShow);
    }
  }
};